import * as React from "react"
import ReactTable, { TableProps as ReactTableProps } from "react-table"
import Popover from "react-bootstrap/Popover"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"

import Button, { ButtonProps } from "./Button"
import "react-table/react-table.css"

interface TableProps<D> extends Partial<ReactTableProps<D>> {
  tableRef?: any
  data: D[]
  onRowClick?: (rowInfo: any) => void
  overrideSelected?: number
  disabled?: boolean
}

interface TableState {
  rowSelected: number
}

class Table<D> extends React.Component<TableProps<D>, TableState> {
  constructor(props: TableProps<D>) {
    super(props)
    this.state = {
      rowSelected: -1
    }
  }

  public componentDidMount() {
    if (this.props.overrideSelected) {
      this.setState({
        rowSelected: this.props.overrideSelected
      })
    }
  }

  public componentDidUpdate = (prevProps: TableProps<D>) => {
    if (this.props.data.length < prevProps.data.length) {
      this.setState(
        {
          // rowSelected: this.props.data.length - 1
          rowSelected: -1
        },
        () => {
          if (this.props.onRowClick) {
            this.props.onRowClick(this.state.rowSelected)
          }
        }
      )
    } else if (this.state.rowSelected && this.props.data.length < this.state.rowSelected) {
      this.setState({
        rowSelected: -1
      })
    }
  }

  public render() {
    const { tableRef, data, onRowClick, getTrProps, resizable, disabled, ...rest } = this.props

    let newOnRowClick = getTrProps
    if (onRowClick) {
      newOnRowClick = (state: any, rowInfo: any, column: any) => {
        return {
          onClick: (e: any) => {
            if (rowInfo && rowInfo.index !== this.state.rowSelected && !disabled) {
              this.setState(
                {
                  rowSelected: rowInfo.index
                },
                () => {
                  if (onRowClick) {
                    onRowClick(rowInfo.index)
                  }
                }
              )
            }
          },
          style: {
            background:
              rowInfo && rowInfo.index === this.state.rowSelected
                ? "#F3F3F7" // trimble modus gray light
                : null,
            cursor: disabled ? "not-allowed" : "pointer"
          }
        }
      }
    }

    return (
      <ReactTable
        ref={tableRef}
        data={data}
        pageSize={data.length}
        showPagination={false}
        resizable={false} // Disabled, causes bug in fixes columns during resize.
        getTrProps={newOnRowClick}
        {...rest}
      />
    )
  }
}

export const AddButton = (props: Omit<ButtonProps, "variant" | "children" | "textOnly" | "iconOnly" | "className">) => {
  return (
    <Button {...props} variant="dark" textOnly={true} iconOnly={true} className="m-auto">
      <i className="modus-icons">circle_add</i>
    </Button>
  )
}

interface ActionPopoverProps {
  renderRolePopover?: () => JSX.Element
  children: React.ReactElement | React.ReactElement[]
}

export const ActionPopover = (props: ActionPopoverProps) => {
  const stopPropagation = (e: any) => {
    e.stopPropagation()
    e.currentTarget.focus() // Popover focus fix for Safari like browsers
  }

  const renderPopover = (
    <Popover id="ActionPropoverItem">
      <Popover.Content>{props.children}</Popover.Content>
    </Popover>
  )

  return (
    <div className="d-flex justify-content-center">
      <OverlayTrigger trigger="focus" placement="left" overlay={renderPopover}>
        <Button
          variant="light" // In order to overwrite the default value
          className="btn-text-dark btn-icon-only"
          onClick={stopPropagation}
        >
          <i className="modus-icons">more_vertical</i>
        </Button>
      </OverlayTrigger>
    </div>
  )
}

export const ActionSelect = (props: ActionPopoverProps) => {
  const stopPropagation = (e: any) => {
    e.stopPropagation()
    e.currentTarget.focus() // Popover focus fix for Safari like browsers
  }

  const renderPopover = (
    <Popover id="ActionPropoverItem">
      <Popover.Content>{props.children}</Popover.Content>
    </Popover>
  )

  return (
    <div className="d-flex justify-content-center">
      <OverlayTrigger trigger="focus" placement="left" overlay={renderPopover}>
        <Button
          variant="light" // In order to overwrite the default value
          className="btn-text-dark btn-icon-only"
          onClick={stopPropagation}
        >
          <i className="modus-icons">more_vertical</i>
        </Button>
      </OverlayTrigger>
    </div>
  )
}

export const ActionPopoverButton = (props: Omit<ButtonProps, "block" | "textOnly" | "iconOnly" | "className">) => {
  const { variant, onClick, ...rest } = props
  const onClickCheckDisabled = props.disabled ? undefined : onClick

  return (
    <span onMouseDown={onClickCheckDisabled}>
      <Button {...rest} variant={variant ? variant : "dark"} textOnly={true} block={true}>
        {props.children}
      </Button>
    </span>
  )
}

export default Table
